<template>
  <div class="flex min-h-screen bg-default">
    <Sidebar />

    <div class="flex min-w-0 flex-1 flex-col pb-20 lg:pb-0">
      <header class="relative flex items-center gap-2.5 overflow-hidden border-b border-default bg-default px-4 py-3 shadow-sm lg:hidden">
        <div class="pointer-events-none absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-primary via-info to-primary" />
        <div class="flex size-9 flex-none items-center justify-center rounded-lg bg-elevated ring-1 ring-default">
          <img :src="meltalIcon" alt="Meltal" class="size-6.5 object-contain" />
        </div>
        <div class="text-base font-bold text-highlighted">{{ t('app.name') }}</div>
      </header>

      <main class="flex-1 p-4 lg:p-8">
        <slot />
      </main>
    </div>

    <BottomNav />

    <LockOverlay />
  </div>
</template>

<script lang="ts" setup>
import { watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

import meltalIcon from '@/assets/meltal-icon.png'
import { useIdleLock } from '@/libs/idleLock'
import { useAppStore } from '@/stores/app'
import BottomNav from './components/BottomNav.vue'
import LockOverlay from './components/LockOverlay.vue'
import Sidebar from './components/Sidebar.vue'

const { t } = useI18n()
const router = useRouter()
const appStore = useAppStore()

// Idle for 5 minutes -> logout (see libs/idleLock.ts).
useIdleLock()

// Every logout (manual lock, idle lock, 401) lands on Domov, which also unmounts whatever
// form the previous person had half filled in. Stores holding drafts clear them through
// appStore.registerLockHandler().
watch(
  () => appStore.isLoggedIn(),
  (loggedIn) => {
    if (!loggedIn) router.replace('/')
  },
)
</script>
